.tree-item {
  display: flex;

  border-bottom: 1px solid rgba(0,0,0,.12);
  padding-bottom: 8px;
  margin-bottom: 6px;
}

.label {
  flex: 1;
  padding-left: 8px;
}

.arrow-icon {
  cursor: pointer;
  font-size: 20px; /* Adjust size as needed */
}

.tree-item-label {
  display: flex;
  /* align-items: center; */
  justify-content: space-between; /* Aligns children at opposite ends */
  width: 100%; /* Ensures the container takes the full width */
  gap: 16px
}

.tree-label-select {
  flex: 1;
  /* align-items: center; */
  display: flex;
  /* padding-top: 6px; */
  padding-right: 8px;
  align-items: center;
}

.tree-item {
  border-bottom: 1px solid rgba(0,0,0,.12);
  padding-bottom: 8px;
  margin-bottom: 6px;
}

.tree-item-label {
  display: flex; 
  width: 100%;
  cursor: pointer;
}

.nested-list {
  margin-left: 20px; 
}

.label-icon-container {
  display: flex;
  align-items: center; 
  border-bottom: 1px solid rgba(0,0,0,.12);
  padding: 4px;
}

/* .tree-label-select {
 
} */


[level="1"] .nested-list { margin-left: 10px; }
[level="2"] .nested-list { margin-left: 20px; }
[level="3"] .nested-list { margin-left: 30px; }
[level="4"] .nested-list { margin-left: 40px; }
[level="5"] .nested-list { margin-left: 50px; }
[level="6"] .nested-list { margin-left: 60px; }
